import React from 'react'
import Select from 'react-select'
import DatePicker from 'react-datepicker';
import _ from 'lodash';
import { Table, Column } from 'fixed-data-table';
import { SortHeaderCell, TextCell } from '../../../commonComponents/DataTable/DataTablePs';

import {
	ControlLabel,
	FormControl,
	FormGroup,
	Row,
	Col,
	Button
} from 'react-bootstrap';


export class MultiSelectField extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			disabled: false,
			crazy: false,
			//options: [],
		}
	}

	toggleDisabled(e) {
		this.setState({ disabled: e.target.checked });
	}

	render() {
		let {
			multiSelectOptions,
			onChange,
		} = this.props;

		return (
			<FormGroup>
				<div className='section'>
					<ControlLabel>{this.props.title || '可複選'}</ControlLabel>
					<Select
						multi
						simpleValue
						disabled={this.state.disabled}
						value={this.props.multiSelectedValues}
						placeholder='請選擇'
						options={multiSelectOptions}
						onChange={onChange} />
				</div>
			</FormGroup>
		);
	}
}

export const EntrySelectField = ({ onChangeHandler, value }) => {
	const list = [
		{ value: 'all', label: '全部' },
		{ value: 'member', label: '成員' },
		{ value: 'group', label: '部門' }
	]

	return (
		<FormGroup>
			<ControlLabel>{'全部/成員/部門'}</ControlLabel>
			<div>
				<Select
					openOnFocus={true}
					value={value}
					matchProp='label'
					clearable={false}
					placeholder='請輸入'
					noResultsText='查無結果'
					onChange={event => onChangeHandler(event, 'filterTarget')}
					options={list} />
			</div>
		</FormGroup>
		// <FormGroup>
		// 	<ControlLabel>全部/成員/部門</ControlLabel>
		// 	<FormControl
		// 		componentClass='select'
		// 		value={value}
		// 		onChange={event => onChangeHandler(event, 'filterTarget')}>
		// 		<option value='all'>全部</option>
		// 		<option value='member'>成員</option>
		// 		<option value='group'>部門</option>
		// 	</FormControl>
		// </FormGroup>
	);
}

export const TypeSelectField = ({ onChangeHandler, value, selectedReportList }) => {
	return (
		<FormGroup>
			<ControlLabel>{'報表類別'}</ControlLabel>
			<div>
				<Select
					openOnFocus={true}
					value={value}
					matchProp='label'
					clearable={false}
					placeholder='請輸入'
					noResultsText='查無結果'
					onChange={event => onChangeHandler(event, 'selectedReportType')}
					options={selectedReportList} />
			</div>
		</FormGroup>
		// <FormGroup>
		// 	<ControlLabel>報表類別</ControlLabel>
		// 	<FormControl
		// 		componentClass='select'
		// 		value={value}
		// 		onChange={event => onChangeHandler(event, 'selectedReportType')}>
		// 		{/* <option value='workLog'>工作日誌</option> */}
		// 		{/* <option value='salesCases'>銷售個案</option> */}
		// 		<option value='repairService'>服務單</option>
		// 		<option value='formQuotation'>估價單</option>
		// 		<option value='formCost'>成本分析表</option>
		// 		<option value='formMargin'>保證金申請單</option>
		// 		<option value='formOrder'>訂單</option>
		// 		<option value='formGoods'>貨品申購書</option>
		// 		<option value='formLading'>領貨單</option>
		// 		<option value='formInvoice'>發票申請單</option>
		// 		<option value='formWarehouse'>入庫單</option>
		// 	</FormControl>
		// </FormGroup>
	);
}

export const DateSelect = ({ label, onChangeDate, time }) => {
	return (
		<FormGroup>
			<ControlLabel>{label === 'searchFrom' ? '起' : '至'}</ControlLabel>
			<FormControl componentClass='div'>
				<DatePicker
					className='report-date-picker'
					dateFormat='YYYY/MM/DD'
					selected={time}
					onChange={date => onChangeDate(label, date)}
				/>
			</FormControl>
		</FormGroup>
	);
}

export const DropDownMenu = props => (
	<FormGroup>
		<ControlLabel>{props.title}</ControlLabel>
		<div>
			<Select
				openOnFocus={true}
				inputProps={{ id: props.id }}
				disabled={props.disabled}
				value={props.value}
				matchProp='label'
				clearable={false}
				placeholder='請輸入'
				noResultsText='查無結果'
				onChange={selectedObject => props.onChange(selectedObject, props.label)}
				options={props.options} />
		</div>
	</FormGroup>
);

export const OptionsGenerator = array => {
	let options = array.map((item, index) => {
		return { value: item.id, label: item.name }
	});
	return options;
}

export const ExportBtn = props => {
	return (
		<Row>
			<Col sm={12}>
				<Button className='btn-export' onClick={props.onClick}>匯出</Button>
			</Col>
		</Row>
	);
}

export const SalesCasesTable = (props) => (
	<Table
		onRowClick={(e, rowIndex) => { props.onRowClick(e, rowIndex, props.dataObj); }}
		rowHeight={50}
		headerHeight={50}
		rowsCount={props.dataObj.getSize()}
		width={props.width}
		height={props.height}>

		<Column
			columnKey='case_createdate'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.case_createdate}>
					建立日期
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={150}
		/>

		{/* <Column
        columnKey='case_name'
        header={
            <SortHeaderCell
            onSortChange={props.onSortChange}
            sortDir={props.sortDir.case_name}>
            個案名稱
            </SortHeaderCell>
        }
        cell={<TextCell sortedData={props.dataObj} />}
        flexGrow={1}
        width={150} 
        /> */}

		<Column
			columnKey='company_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.company_name}>
					公司名稱
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={150}
		/>

		<Column
			columnKey='caseStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.caseStatusName}>
					個案狀態
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={120}
		/>

		<Column
			columnKey='casePurchmentStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.casePurchmentStatusName}>
					採購狀態
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={120}
		/>

		<Column
			columnKey='caseProbabilityName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.caseProbabilityName}>
					結案機率
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={120}
		/>

		<Column
			columnKey='case_owner_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.case_owner_name}>
					建立者
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={120}
		/>

		<Column
			columnKey='caseTypeName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.caseTypeName}>
					個案分類
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={120}
		/>

		<Column
			columnKey='case_quoteday'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.case_quoteday}>
					報價日期
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={150}
		/>

		<Column
			columnKey='case_dealday'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.case_dealday}>
					預計成交日
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={150}
		/>

		<Column
			columnKey='case_remark'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.case_remark}>
					備註
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={150}
		/>

		{/* <Column
        columnKey='discussing'
        header={
            <SortHeaderCell
            onSortChange={props.onSortChange}
            sortDir={props.sortDir.discussing}>
            討論
            </SortHeaderCell>
        }
        cell={<TextCell sortedData={props.dataObj} />}
        flexGrow={0}
        width={100} 
        /> */}
	</Table>
);

export const RepairServiceTable = (props) => (
	<Table
		onRowClick={(e, rowIndex) => { props.onRowClick(e, rowIndex, props.dataObj); }}
		rowHeight={50}
		headerHeight={50}
		rowsCount={props.dataObj.getSize()}
		width={props.width}
		height={props.height}>
		<Column
			columnKey='status_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.status_name}>
					{'狀態'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={80}
		/>
		<Column
			columnKey='request_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.request_date}>
					{'報修日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			width={110}
			flexGrow={2}
		/>

		<Column
			columnKey='repair_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.repair_id}>
					{'維修單編號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			width={120}
			flexGrow={1}
		/>

		<Column
			columnKey='area_type_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.area_type_name}>
					{'區域'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			width={110}
			flexGrow={2}
		/>
		<Column
			columnKey='company_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.company_name}>
					{'公司'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			width={100}
			flexGrow={3}
		/>
		<Column
			columnKey='model_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.model_name}>
					{'產品'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			width={100}
			flexGrow={2}
		/>
		<Column
			columnKey='serial_number'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.serial_number}>
					{'產品序號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			width={100}
			flexGrow={2}
		/>
		<Column
			columnKey='issue_description'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.issue_description}>
					{'報修內容'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			width={200}
			flexGrow={5}
		/>
		<Column
			columnKey='create_user'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.create_user}>
					{'建立者'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			width={100}
			flexGrow={2}
		/>
		<Column
			columnKey='fix_user_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.fix_user_name}>
					{'服務人員'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			width={100}
			flexGrow={2}
		/>
		<Column
			columnKey='warranty_type_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.warranty_type_name}>
					{'保固/維護合約'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			width={140}
			flexGrow={2}
		/>
	</Table>
);

export const FormQuotationTable = (props) => (
	<Table
		onRowClick={(e, rowIndex) => { props.onRowClick(e, rowIndex, props.dataObj); }}
		rowHeight={50}
		headerHeight={50}
		rowsCount={props.dataObj.getSize()}
		width={props.width}
		height={props.height}>
		<Column
			columnKey='doc_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.doc_id}>
					{'單號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='reviewStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.reviewStatusName}>
					{'狀態'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='typeName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.typeName}>
					{'表單類型'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='stageName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.stageName}>
					{'案況進度'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='takeName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.takeName}>
					{'預計取件'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='modelName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.modelName}>
					{'商業模式'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='request_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.request_name}>
					{'申請人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='quotation_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.quotation_date}>
					{'報價日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='expiry_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.expiry_date}>
					{'有效日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='deliveryName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.deliveryName}>
					{'取件方式'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_id}>
					{'客戶編號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_name}>
					{'客戶名稱'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={200}
		/>
		<Column
			columnKey='customer_address'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_address}>
					{'客戶地址'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={200}
		/>
		<Column
			columnKey='contact_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_name}>
					{'聯絡人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='contact_tel'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_tel}>
					{'聯絡電話'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='contact_email'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_email}>
					{'Email'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={150}
		/>
		<Column
			columnKey='currencyName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.currencyName}>
					{'幣別'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='taxName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.taxName}>
					{'稅別'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='machineName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.machineName}>
					{'產品類型'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='brandName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.brandName}>
					{'廠牌'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='creator_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.creator_name}>
					{'建立者'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
	</Table>
);

export const FormCostTable = (props) => (
	<Table
		onRowClick={(e, rowIndex) => { props.onRowClick(e, rowIndex, props.dataObj); }}
		rowHeight={50}
		headerHeight={50}
		rowsCount={props.dataObj.getSize()}
		width={props.width}
		height={props.height}>
		<Column
			columnKey='doc_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.doc_id}>
					{'單號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='reviewStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.reviewStatusName}>
					{'狀態'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='typeName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.typeName}>
					{'表單類型'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='request_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.request_name}>
					{'申請人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='quotation_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.quotation_date}>
					{'報價日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='expiry_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.expiry_date}>
					{'有效日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_id}>
					{'客戶編號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_sname'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_sname}>
					{'客戶名稱'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={200}
		/>
		<Column
			columnKey='customer_address'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_address}>
					{'客戶地址'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={200}
		/>
		<Column
			columnKey='contact_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_name}>
					{'聯絡人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='contact_tel'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_tel}>
					{'聯絡電話'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='contact_email'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_email}>
					{'Email'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={150}
		/>
		<Column
			columnKey='currencyName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.currencyName}>
					{'幣別'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='taxName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.taxName}>
					{'稅別'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='machineName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.machineName}>
					{'產品類型'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='brandName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.brandName}>
					{'廠牌'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='creator_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.creator_name}>
					{'建立者'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
	</Table>
);

export const FormMarginTable = (props) => (
	<Table
		onRowClick={(e, rowIndex) => { props.onRowClick(e, rowIndex, props.dataObj); }}
		rowHeight={50}
		headerHeight={50}
		rowsCount={props.dataObj.getSize()}
		width={props.width}
		height={props.height}>
		<Column
			columnKey='doc_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.doc_id}>
					{'單號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='reviewStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.reviewStatusName}>
					{'狀態'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='typeName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.typeName}>
					{'表單類型'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='request_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.request_name}>
					{'申請人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='case_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.case_id}>
					{'案號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_id}>
					{'客戶編號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_name}>
					{'客戶名稱'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={200}
		/>
		<Column
			columnKey='department'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.department}>
					{'採購單位'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={100}
		/>
		<Column
			columnKey='case_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.case_name}>
					{'案名'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='product_ename'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.product_ename}>
					{'英文品名'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={150}
		/>
		<Column
			columnKey='create_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.create_date}>
					{'建立日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='open_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.open_date}>
					{'開標日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='creator_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.creator_name}>
					{'建立者'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
	</Table>
);

export const FormOrderTable = (props) => (
	<Table
		onRowClick={(e, rowIndex) => { props.onRowClick(e, rowIndex, props.dataObj); }}
		rowHeight={50}
		headerHeight={50}
		rowsCount={props.dataObj.getSize()}
		width={props.width}
		height={props.height}>
		<Column
			columnKey='doc_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.doc_id}>
					{'單號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='reviewStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.reviewStatusName}>
					{'狀態'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='typeName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.typeName}>
					{'表單類型'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='orderName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.orderName}>
					{'訂單確認方式'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={150}
		/>
		<Column
			columnKey='takeName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.takeName}>
					{'預計取件'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='modelName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.modelName}>
					{'商業模式'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='request_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.request_name}>
					{'申請人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='quotation_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.quotation_date}>
					{'報價日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='expiry_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.expiry_date}>
					{'有效日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_id}>
					{'客戶編號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_name}>
					{'客戶名稱'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={200}
		/>
		<Column
			columnKey='customer_address'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_address}>
					{'客戶地址'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={200}
		/>
		<Column
			columnKey='contact_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_name}>
					{'聯絡人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='contact_tel'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_tel}>
					{'聯絡電話'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='contact_email'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_email}>
					{'Email'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={150}
		/>
		<Column
			columnKey='currencyName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.currencyName}>
					{'幣別'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='taxName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.taxName}>
					{'稅別'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='machineName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.machineName}>
					{'產品類型'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='brandName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.brandName}>
					{'廠牌'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='creator_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.creator_name}>
					{'建立者'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
	</Table>
);

export const FormGoodsTable = (props) => (
	<Table
		onRowClick={(e, rowIndex) => { props.onRowClick(e, rowIndex, props.dataObj); }}
		rowHeight={50}
		headerHeight={50}
		rowsCount={props.dataObj.getSize()}
		width={props.width}
		height={props.height}>
		<Column
			columnKey='doc_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.doc_id}>
					{'單號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='reviewStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.reviewStatusName}>
					{'狀態'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='modelName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.modelName}>
					{'商業模式'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='caseStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.caseStatusName}>
					{'單況'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='request_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.request_name}>
					{'申請人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='purchaseName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.purchaseName}>
					{'用途'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='purchase_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.purchase_date}>
					{'訂購日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_id}>
					{'客戶編號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_name}>
					{'客戶名稱'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={200}
		/>
		<Column
			columnKey='contact_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_name}>
					{'聯絡人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='contract_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contract_date}>
					{'合約書交貨期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={150}
		/>
		<Column
			columnKey='delivery_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.delivery_date}>
					{'期望交貨期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='currencyName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.currencyName}>
					{'幣別'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='tradeName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.tradeName}>
					{'貿易條件'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='get_amount'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.get_amount}>
					{'得標金額'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='creator_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.creator_name}>
					{'建立者'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
	</Table>
);

export const FormLadingTable = (props) => (
	<Table
		onRowClick={(e, rowIndex) => { props.onRowClick(e, rowIndex, props.dataObj); }}
		rowHeight={50}
		headerHeight={50}
		rowsCount={props.dataObj.getSize()}
		width={props.width}
		height={props.height}>
		<Column
			columnKey='doc_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.doc_id}>
					{'單號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='reviewStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.reviewStatusName}>
					{'狀態'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='modelName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.modelName}>
					{'商業模式'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='request_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.request_name}>
					{'申請人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='create_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.create_date}>
					{'建立日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_id}>
					{'客戶編號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_name}>
					{'客戶名稱'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={200}
		/>
		<Column
			columnKey='contact_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_name}>
					{'聯絡人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='work_phone'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.work_phone}>
					{'連絡電話'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='delivery_address'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.delivery_address}>
					{'送貨地址'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={200}
		/>
		<Column
			columnKey='invoice_address'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.invoice_address}>
					{'發票地址'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='deliveryName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.deliveryName}>
					{'寄送方式'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='delivery_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.delivery_date}>
					{'寄送日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='deliveryStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.deliveryStatusName}>
					{'寄送狀態'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='ladingName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.ladingName}>
					{'類型'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='reason'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.reason}>
					{'原因'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='creator_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.creator_name}>
					{'建立者'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
	</Table>
);

export const FormInvoiceTable = (props) => (
	<Table
		onRowClick={(e, rowIndex) => { props.onRowClick(e, rowIndex, props.dataObj); }}
		rowHeight={50}
		headerHeight={50}
		rowsCount={props.dataObj.getSize()}
		width={props.width}
		height={props.height}>
		<Column
			columnKey='doc_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.doc_id}>
					{'單號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='reviewStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.reviewStatusName}>
					{'狀態'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='modelName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.modelName}>
					{'商業模式'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='request_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.request_name}>
					{'申請人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='create_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.create_date}>
					{'建立日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_id}>
					{'客戶編號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_name}>
					{'客戶名稱'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={200}
		/>
		<Column
			columnKey='contact_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_name}>
					{'聯絡人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='work_phone'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.work_phone}>
					{'連絡電話'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='invoice_address'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.invoice_address}>
					{'發票地址'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={200}
		/>
		<Column
			columnKey='deliveryName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.deliveryName}>
					{'寄送方式'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='delivery_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.delivery_date}>
					{'寄送日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='deliveryStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.deliveryStatusName}>
					{'寄送狀態'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='invoicePurposeName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.invoicePurposeName}>
					{'類型'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='reason'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.reason}>
					{'原因'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='invoice_number'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.invoice_number}>
					{'發票號碼'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='order_number'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.order_number}>
					{'銷貨單單據號碼'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={150}
		/>
		<Column
			columnKey='creator_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.creator_name}>
					{'建立者'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
	</Table>
);

export const FormWarehouseTable = (props) => (
	<Table
		onRowClick={(e, rowIndex) => { props.onRowClick(e, rowIndex, props.dataObj); }}
		rowHeight={50}
		headerHeight={50}
		rowsCount={props.dataObj.getSize()}
		width={props.width}
		height={props.height}>
		<Column
			columnKey='doc_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.doc_id}>
					{'單號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='reviewStatusName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.reviewStatusName}>
					{'狀態'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='warehouseName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.warehouseName}>
					{'類別'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='request_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.request_name}>
					{'申請人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='create_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.create_date}>
					{'建立日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='storage_date'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.storage_date}>
					{'入庫日期'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_id'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_id}>
					{'客戶編號'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='customer_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.customer_name}>
					{'客戶名稱'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={1}
			width={200}
		/>
		<Column
			columnKey='contact_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.contact_name}>
					{'聯絡人'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='takeTypeName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.takeTypeName}>
					{'領貨別'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='borrow_number'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.borrow_number}>
					{'單據號碼'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='invoiceHandleName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.invoiceHandleName}>
					{'發票處理方式'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={150}
		/>
		<Column
			columnKey='invoice_number'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.invoice_number}>
					{'發票號碼'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='reasonName'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.reasonName}>
					{'退貨原因'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
		<Column
			columnKey='warehouse_remark'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.warehouse_remark}>
					{'備註'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={200}
		/>
		<Column
			columnKey='creator_name'
			header={
				<SortHeaderCell
					onSortChange={props.onSortChange}
					sortDir={props.sortDir.creator_name}>
					{'建立者'}
				</SortHeaderCell>
			}
			cell={<TextCell sortedData={props.dataObj} />}
			flexGrow={0}
			width={100}
		/>
	</Table>
);


// WEBPACK FOOTER //
// ./src/salesky/routes/report/ReportPs.jsx